import React, { useEffect, useRef, useState } from 'react';
import progressBus from '../../utils/progressBus';
import './GlobalProgressBar.css';

/**
 * 화면 상단 진행 바 (YouTube/nprogress 식). progressBus 의 활성 상태로 구동된다.
 * - 로딩 시작 150ms 안에 끝나는 빠른 요청은 바를 띄우지 않음(깜빡임 방지)
 * - 그보다 길면: 0.08 → 0.9 로 점점 느리게 차오르고(trickle), 끝나면 100% 채운 뒤 페이드아웃
 * - 동시 요청은 progressBus 가 count 로 묶어 한 번만 표시
 */
function GlobalProgressBar() {
    const [scale, setScale] = useState(0);
    const [visible, setVisible] = useState(false);
    const [fading, setFading] = useState(false);
    const shownRef = useRef(false);
    const showTimer = useRef(null);
    const trickle = useRef(null);
    const finish = useRef(null);

    useEffect(() => {
        const clearAll = () => {
            clearTimeout(showTimer.current);
            clearInterval(trickle.current);
            clearTimeout(finish.current);
        };

        const show = () => {
            shownRef.current = true;
            setFading(false);
            setVisible(true);
            setScale(0.08);
            trickle.current = setInterval(() => {
                setScale((s) => (s >= 0.9 ? s : s + (0.9 - s) * 0.1));
            }, 220);
        };

        const hide = () => {
            clearInterval(trickle.current);
            setScale(1); // 100% 채우고
            finish.current = setTimeout(() => {
                setFading(true); // 페이드아웃
                finish.current = setTimeout(() => {
                    shownRef.current = false;
                    setVisible(false);
                    setFading(false);
                    setScale(0);
                }, 280);
            }, 80);
        };

        const unsub = progressBus.subscribe((active) => {
            if (active) {
                clearAll();
                showTimer.current = setTimeout(show, 150); // 빠른 로드는 생략
            } else {
                clearTimeout(showTimer.current);
                clearInterval(trickle.current);
                if (shownRef.current) hide();
            }
        });

        return () => {
            unsub();
            clearAll();
        };
    }, []);

    if (!visible) return null;

    return (
        <div className="route-progress" aria-hidden="true">
            <div
                className={`route-progress-bar ${fading ? 'is-fading' : ''}`}
                style={{ transform: `scaleX(${scale})` }}
            />
        </div>
    );
}

/**
 * Suspense fallback 용 — 화면엔 아무것도 안 그리고 progressBus 만 켜고 끈다.
 * (lazy 청크 로딩도 같은 상단 바로 표시되도록)
 */
export function SuspenseProgress() {
    useEffect(() => {
        progressBus.start();
        return () => progressBus.done();
    }, []);
    return null;
}

export default GlobalProgressBar;
